import { IDatesModalState } from '../../../types/filters/datesModal';
import { IApplicationState } from '../../../types/redux';

export function selectDatesModalState(state: IApplicationState): IDatesModalState {
  return state.filters.datesModal;
}
